export default __webpack_public_path__ + "static/media/view1_week_country.9a3d3edf.csv";